import { ACCENT_PURPLE } from '../BalanceSheet/balanceSheetAdapters'

// The layout the financial statement tabs share (rail card, banner, tiles, section cards, tables).
// A tab spreads these first and keeps its own keys after them, so a tab-specific override still wins.
export const reportStyles = (theme) => ({
  container: {
    padding: theme.spacing(3),
    backgroundColor: 'white',
    minHeight: '400px'
  },
  centeredState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '400px',
    textAlign: 'center'
  },
  layout: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  sidebarCard: {
    padding: theme.spacing(2),
    borderRadius: '12px',
    border: '1px solid #E0E0E0',
    boxShadow: 'none'
  },
  sidebarHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1.5)
  },
  sidebarHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1)
  },
  statusChip: {
    fontSize: 10,
    fontWeight: 700,
    height: 20
  },
  periodsRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5)
  },
  periodItemActive: {
    borderColor: ACCENT_PURPLE,
    backgroundColor: 'rgba(155,138,251,0.06)',
    borderLeft: `3px solid ${ACCENT_PURPLE}`
  },
  periodDate: {
    fontWeight: 600,
    fontSize: 13
  },
  periodStatus: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '0.04em'
  },
  periodValue: {
    fontWeight: 700,
    fontSize: 16,
    marginTop: 2
  },
  periodMeta: {
    fontSize: 11,
    color: 'var(--neutral-400)'
  },
  periodBar: {
    height: 3,
    borderRadius: 2,
    backgroundColor: '#EDEDED',
    marginTop: theme.spacing(1),
    overflow: 'hidden'
  },
  periodBarFill: {
    height: '100%',
    borderRadius: 2
  },
  bannerEyebrow: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.08em',
    marginBottom: theme.spacing(1)
  },
  bannerHeadline: {
    fontSize: 30,
    fontWeight: 700,
    lineHeight: 1.15,
    marginBottom: theme.spacing(1.5)
  },
  bannerDescription: {
    fontSize: 14,
    lineHeight: 1.6,
    color: 'rgba(255,255,255,0.78)',
    maxWidth: 820
  },
  bannerBullets: {
    margin: `${theme.spacing(1.5)}px 0 0`,
    paddingLeft: 18,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    fontSize: 13,
    lineHeight: 1.5,
    color: 'rgba(255,255,255,0.7)',
    maxWidth: 820
  },
  bannerObservationsHead: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '0.08em',
    color: ACCENT_PURPLE,
    marginTop: theme.spacing(2),
    marginBottom: 4
  },
  bannerObservations: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    fontSize: 13,
    lineHeight: 1.5,
    color: 'rgba(255,255,255,0.7)',
    maxWidth: 820
  },
  bannerObservation: {
    display: 'flex',
    gap: 10,
    alignItems: 'flex-start'
  },
  bannerObservationDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: ACCENT_PURPLE,
    flexShrink: 0,
    marginTop: 7
  },
  bannerScoreCol: {
    textAlign: 'right',
    flexShrink: 0
  },
  bannerScoreLabel: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '0.08em',
    color: 'rgba(255,255,255,0.6)'
  },
  bannerScoreValue: {
    fontSize: 44,
    fontWeight: 700,
    lineHeight: 1.1
  },
  bannerScoreUnit: {
    fontSize: 16,
    fontWeight: 600,
    color: 'rgba(255,255,255,0.6)',
    marginLeft: 4
  },
  bannerTrend: {
    fontSize: 11,
    color: 'rgba(255,255,255,0.7)',
    marginTop: 6
  },
  dotStrip: {
    display: 'flex',
    gap: 3,
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1)
  },
  dot: {
    width: 12,
    height: 4,
    borderRadius: 2,
    backgroundColor: 'rgba(255,255,255,0.18)'
  },
  tile: {
    flex: '1 1 220px',
    minWidth: 220,
    padding: theme.spacing(2),
    borderRadius: '12px',
    border: '1px solid #E8E8E8',
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 4
  },
  tileLabel: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: '0.08em',
    color: 'var(--neutral-400)'
  },
  sectionHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: 12,
    flexWrap: 'wrap'
  },
  flagLine: {
    fontSize: 13,
    fontWeight: 600
  },
})
